<template>
  <div class="page">
    <el-form inline size="medium">
      <el-form-item>
        <date-time-range-picker
            :end-time.sync="searchForm.endTime"
            :start-time.sync="searchForm.startTime"/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleBatchExport">{{ $t('导出') }}</el-button>
      </el-form-item>
    </el-form>

    <el-tabs v-model="activeTab">
      <el-tab-pane  v-for="(item, index) in list"  :label="$t(item.name)" :name="item.action" :key="index"></el-tab-pane>
    </el-tabs>

    <keep-alive>
      <component :is="activeTab"
                 v-for="tab in [activeTab]"
                 :key="tab"
                 :searchParams="searchForm"
                 :title="$t(activeItem.name)"
                 :action="dataApi[activeItem.action]"
                 @select="handleSelect"/>
    </keep-alive>
  </div>
</template>

<script>
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import DeviceCardTable from "@/components/stat-device/DeviceCardTable";
import {request} from "@/config/request";
import {downloadFile} from "@/utils/common";

export default {
  name: "StatDevice",
  components: {
    DateTimeRangePicker,
    smartUnitCountList: DeviceCardTable,
    valuationModeCount: DeviceCardTable,
    weighModeCount: DeviceCardTable,
    sectionModeCount: DeviceCardTable,
    momentPowerModeCount: DeviceCardTable,
    photoModeCount: DeviceCardTable,
    medicineModeCount: DeviceCardTable,
    expressModeCount: DeviceCardTable,
    totalWeighCount: DeviceCardTable,
    countModeCount: DeviceCardTable,
    smartWeighCount: DeviceCardTable,
    hardwareTestCount: DeviceCardTable,
    lonLatCorrectCount: DeviceCardTable,
    precisionAdjustCount: DeviceCardTable,
    multiunitWeighCount: DeviceCardTable,
  },
  data() {
    return {
      dataApi: {
        smartUnitCountList: this.$api.data.smartUnitCountList,
        multiunitWeighCountList: this.$api.data.multiunitWeighCountList,
        valuationModeCount: this.$api.data.valuationModeCount,
        weighModeCount: this.$api.data.weighModeCount,
        sectionModeCount: this.$api.data.sectionModeCount,
        momentPowerModeCount: this.$api.data.momentPowerModeCount,
        photoModeCount: this.$api.data.photoModeCount,
        medicineModeCount: this.$api.data.medicineModeCount,
        expressModeCount: this.$api.data.expressModeCount,
        totalWeighCount: this.$api.data.totalWeighCount,
        countModeCount: this.$api.data.countModeCount,
        smartWeighCount: this.$api.data.smartWeighCount,
        hardwareTestCount: this.$api.data.hardwareTestCount,
        lonLatCorrectCount: this.$api.data.lonLatCorrectCount,
        precisionAdjustCount: this.$api.data.precisionAdjustCount,
        multiunitWeighCount: this.$api.data.multiunitWeighCount,
      },
      list: [
        {name: "智能单位", action: "smartUnitCountList", exportKey: "smartUnitCountCodes"},
        {name: "计价模式", action: "valuationModeCount", exportKey: "valuationModeCountCodes"},
        {name: "称重模式", action: "weighModeCount", exportKey: "weighModeCountCodes"},
        {name: "区间模式", action: "sectionModeCount", exportKey: "sectionModeCountCodes"},
        {name: "瞬力模式", action: "momentPowerModeCount", exportKey: "momentPowerModeCountCodes"},
        {name: "拍照模式", action: "photoModeCount", exportKey: "photoModeCountCodes"},
        {name: "药物换算", action: "medicineModeCount", exportKey: "medicineModeCountCodes"},
        {name: "快递模式", action: "expressModeCount", exportKey: "expressModeCountCodes"},
        {name: "累计称重", action: "totalWeighCount", exportKey: "totalWeighCountCodes"},
        {name: "计数模式", action: "countModeCount", exportKey: "countModeCountCodes"},
        {name: "智能称重", action: "smartWeighCount", exportKey: "smartWeighCountCodes"},
        {name: "硬件检测", action: "hardwareTestCount", exportKey: "hardwareTestCountCodes"},
        {name: "经纬度校正", action: "lonLatCorrectCount", exportKey: "lonLatCorrectCountCodes"},
        {name: "精度调整", action: "precisionAdjustCount", exportKey: "precisionAdjustCountCodes"},
        {name: '多单称重', action: 'multiunitWeighCount', exportKey: "multiunitWeighCountCodes"},
      ],

      exportApiList: [
        this.$api.exportData.smartUnitCount,
        this.$api.exportData.valuationModeCount,
        this.$api.exportData.weighModeCount,
        this.$api.exportData.sectionModeCount,
        this.$api.exportData.momentPowerModeCount,
        this.$api.exportData.photoModeCount,
        this.$api.exportData.medicineModeCount,
        this.$api.exportData.expressModeCount,
        this.$api.exportData.totalWeighCount,
        this.$api.exportData.countModeCount,
        this.$api.exportData.smartWeighCount,
        this.$api.exportData.hardwareTestCount,
        this.$api.exportData.lonLatCorrectCount,
        this.$api.exportData.precisionAdjustCount,
        this.$api.exportData.multiunitWeighCount,
      ],
      activeTab: "smartUnitCountList",
      searchForm: {},
      exportForm: {}
    }
  },
  methods: {
    handleSelect(devices) {
      const exportKey = this.list.find(item => item.action === this.activeTab)?.exportKey;
      this.exportForm[exportKey] = devices;
      console.log("exportForm", this.exportForm);
    },

    // 批量导出
    async handleBatchExport() {
      try {
        const res = await request(this.$api.common.smartUnitExport, this.exportForm, {isJson: true});
        downloadFile(res.excelUrl);
      } catch (e) {
        console.log(e);
      }
    },

    handleExport() {
      const ids = this.exportForm;
      console.log(ids)
      const index = this.list.findIndex(item => item.name === this.activeTab);
      let url = this.exportApiList[index] += `?deviceIds=${ids.join(",")}`;
      const a = document.createElement("a");
      console.log("url", url)
      a.href = url;
      a.click();
    }
  },
  computed: {
    activeItem() {
      return this.list.find(item => item.action === this.activeTab);
    }
  }
}
</script>

<style scoped>

.page {
  height: 99%;
  display: flex;
  flex-direction: column;
}

.el-form {
  background: #FFFFFF;
  border-radius: 4px;
  padding: 10px 10px 0 10px;
  margin-bottom: 16px;
  z-index: 999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.content {
  flex: 1;
  overflow: auto;
}

.el-tabs {
  background: #FFFFFF;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 0 18px 18px;
}

</style>












